import {TextInput} from "component/input/TextInput";
import {useContext} from "react";
import {Context} from "./Context";
import {includes, Translator} from "component/const/ForTrans";
import "./Style.css"
import {AboutTest} from "../../../component/AboutTest";
import {parsingInt} from "component/const/Functions";

export default function SubmitMetaData() {

    const {metaData, setMetaData, testTranslator} = useContext(Context)

    const onChange = (value, toChange) => {
        setMetaData(prev => ({
            ...prev,
            [toChange]: value
        }))
    }

    const variable = {
        header: ["AI 번역기 (최대 4개 선택)", "총점", "합격 점수", "관리자 확인 점수"],
        testOverview: {toChange: "testOverview", placeholder: "입력하세요"},
        submitterMemo: {toChange: "submitterMemo", placeholder: "입력하세요"}
    }

    return (<>
        <AboutTest subTitle={"시험 정보"} title={'시험 출제하기'} metaData={metaData} onChange={onChange}>
        <table>
            <thead>
            <tr>
                {variable.header?.map((it, index) => (
                    <th style={index > 0 && index !==3? {width: "100px"} : null} key={it + index.toString()}>{it}</th>))}
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    {Translator.map((it, index) =>
                        (<label key={`Create Trans SubmitMetaData checkBox ${index}`}>
                            <input type="checkbox" style={{height:"auto"}}
                                checked={includes(testTranslator, it)}/>
                            {it}
                        </label>))}
                </td>
                <td><TextInput value={metaData} type="number" toChange="max" onChange={onChange} disabled={true}/></td>
                <td><TextInput value={metaData} type="number" toChange="pass" onChange={onChange} disabled={true}/></td>
                <td><input value={metaData.checkStart} className="input" placeholder={'입력하세요'}
                           disabled={true} onChange={e=>
                    onChange(parsingInt(e.target.value),"checkStart")}/>
                    ~
                    <input value={metaData.checkEnd} className="input" placeholder={'입력하세요'}
                           disabled={true} onChange={e =>
                        onChange(parsingInt(e.target.value),"checkEnd")}/>
                </td>
            </tr>
            </tbody>
        </table>
        </AboutTest>
    </>)
}
